import { Container, Row, Col } from "react-bootstrap";
import DashboardCard from "./DashboardCard";
import Card from "react-bootstrap/Card";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import DashboardChart from "./DashboardChart";
import { S3_URL } from "../services/Constants";
import {
  fetchErrorTransactionData,
  fetchUnknownFacilityTransactionData,
} from "../services/errorMessageQueue-service";
import { fetchReportData } from "../services/reports-services";
import { fetchStatisticsData } from "../services/dashboard-statistics-services";
import moment from "moment";
import DashboardChartMessageStatisticsByFacility from "./DashboardChartMessageStatisticsByFacility";
import Cookies from "js-cookie";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { DSCards, DMStats, DEStats } from "../util/component-codes";

const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: "#0365C0",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#0839AD",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#000000",
      fontWeight: theme.typography.fontWeightBold,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#000000",
    },
  })
);

const Dashboard = () => {
  const [messageTab, setMessageTab] = useState("1");
  const [errorTab, setErrorTab] = useState("1");
  const [messInErrorQueue, setMessInErrorQueue] = useState(0);
  const [messInUnknownQueue, setMessInUnknownQueue] = useState(0);
  const [messRecievedToday, setMessRecievedToday] = useState(0);
  const [messProcessedToday, setMessProcessedToday] = useState(0);
  const [statsPerDay, setStatsPerDay] = useState([]);
  const [statsPerWeek, setStatsPerWeek] = useState([]);
  const [statsPerFacility, setStatsPerFacility] = useState([]);
  const [errorsPerDay, setErrorsPerDay] = useState([]);
  const [errorsPerWeek, setErrorsPerWeek] = useState([]);
  const [errorsPerFacility, setErrorsPerFacility] = useState([]);
  const [alertMessage, setAlertMessage] = useState();

  const [user] = useContext(UserContext);

  const fallbackArrayForError = [
    {
      label: "No Data",
      errorQueue: 0,
      unknownProvider: 0,
    },
  ];

  const getErrorTransactions = async () => {
    let response = await fetchErrorTransactionData(0, 5);
    if (response.ok) {
      let data = await response.json();
      if (data.totalRecords != null) {
        setMessInErrorQueue(data.totalRecords);
      }
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const getErrorUnknownFacilities = async () => {
    let response = await fetchUnknownFacilityTransactionData(0, 5);

    if (response.ok) {
      let data = await response.json();
      if (data.totalRecords != null) {
        setMessInUnknownQueue(data.totalRecords);
      }
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const getMessProcessedToday = async () => {
    let data = await fetchStatisticsData("messagesProcessedToday");
    if (Array.isArray(data)) {
      setMessProcessedToday(data[0].messagesProcessed);
    }
    //else set Error
  };

  const getMessRecievedToday = async () => {
    let data = await fetchStatisticsData(
      "messagesRecievedToday"
    );
    if (data?.length > 0) {
      setMessRecievedToday(data[0].messagesReceived);
    }
  };

  const getStatisticsDataPerDay = async () => {
    let data = await fetchStatisticsData("messagesPerDay");
    if (Array.isArray(data)) {
      setStatsPerDay(data);
    }
    //else set Error
  };

  const getStatisticsDataPerLast4Weeks = async () => {
    let data = await fetchStatisticsData("messagesPerWeek");
    if (Array.isArray(data)) {
      setStatsPerWeek(data);
    }
    //else set Error
  };

  const getStatisticsDataBySendingFacility = async () => {
    let data = await fetchStatisticsData("messagesBySendingFacility/1"); // /1 represents the number of days
    if (Array.isArray(data)) {
      setStatsPerFacility(data);
    }
    //else set Error
  };

  const getErrorsDataPerDay = async () => {
    let data = await fetchStatisticsData("errorsPerDay");
    if (Array.isArray(data)) {
      setErrorsPerDay(data);
    } else {
      setErrorsPerDay(fallbackArrayForError);
    }
  };

  const getErrorsDataPerLast4Weeks = async () => {
    let data = await fetchStatisticsData("errorsPerWeek");
    if (Array.isArray(data)) {
      setErrorsPerWeek(data);
    } else {
      setErrorsPerWeek(fallbackArrayForError);
    }
  };

  const getErrorsDataBySendingFacility = async () => {
    let data = await fetchStatisticsData("errorsBySendingFacility");
    if (Array.isArray(data)) {
      setErrorsPerFacility(data);
    } else {
      setErrorsPerFacility(fallbackArrayForError);
    }
  };

  const handleMessageTabChange = (event, newValue) => {
    setMessageTab(newValue);
    switch (newValue) {
      case "1":
        getStatisticsDataPerDay();
        break;
      case "2":
        getStatisticsDataPerLast4Weeks();
        break;
      case "3":
        getStatisticsDataBySendingFacility();
        break;
      default:
        break;
    }
  };
  const handleErrorTabChange = (event, newValue) => {
    setErrorTab(newValue);
    switch (newValue) {
      case "1":
        getErrorsDataPerDay();
        break;
      case "2":
        getErrorsDataPerLast4Weeks();
        break;
      case "3":
        getErrorsDataBySendingFacility();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    getMessProcessedToday();
    getErrorTransactions();
    getErrorUnknownFacilities();
    getMessRecievedToday();
    getStatisticsDataPerDay();
    getErrorsDataPerDay();
  }, []);

  return (
    <>
      <Container fluid className="dashboardContainer">
        <Row>
          <Col xl={8}>
            <Row className="textBig generalFont">
              Welcome {JSON.parse(Cookies.get("userInfoFromOkta"))?.name},
            </Row>

            <Row className="textMedium generalFont">
              Today is {moment().format("Do MMMM YYYY")} and here is your
              summary for today.
            </Row>
            {componentIsVisible(DSCards, user) && (
              <Row className="dashboardCardRow">
                <DashboardCard
                  message="Errors in Message Queue"
                  value={messInErrorQueue}
                  image={`${validateAndSanitizeUrl(S3_URL)}mess-error-queue.png`}
                />
                <DashboardCard
                  message="Errors in Unknown Facility Queue"
                  value={messInUnknownQueue}
                  image={`${validateAndSanitizeUrl(S3_URL)}mess-faciility-queue.png`}
                />
                <DashboardCard
                  message="Messages Received Today"
                  value={messRecievedToday}
                  image={`${validateAndSanitizeUrl(S3_URL)}mess-recieved-today.png`}
                />
                <DashboardCard
                  message="Messages Processed Today"
                  value={messProcessedToday}
                  image={`${validateAndSanitizeUrl(S3_URL)}mess-recieved-today.png`}
                />
              </Row>
            )}
          </Col>
          <Col xl={4} className="dashboardImg">
            <img src={`${validateAndSanitizeUrl(S3_URL)}dashboard-img.png`} alt=""></img>
          </Col>
        </Row>
      </Container>

      {componentIsVisible(DMStats, user) && (
        <Container fluid className="cardContainer">
          <Card className="card">
            <Row>
              <Col>
                <Row>
                  <Card.Body>
                    <div className="cardBody">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}graph-img.png`}
                        className="graphImgStyle"
                        alt=""
                      ></img>
                      Message Statistics
                    </div>
                  </Card.Body>
                </Row>
                <Row>
                  <Box sx={{ width: "100%", typography: "body1" }}>
                    <TabContext value={messageTab}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleMessageTabChange}
                          aria-label="Message Statistics"
                        >
                          <AntTab label="Received by Day" value="1" />
                          <AntTab label="By Week" value="2" />
                          <AntTab label="By Sending Facility" value="3" />
                        </TabList>
                      </Box>
                      <TabPanel value="1">
                        <DashboardChart
                          statisticsData={statsPerDay}
                          statsTotalLabel={"in Last 7 Days"}
                        />
                      </TabPanel>
                      <TabPanel value="2">
                        <DashboardChart
                          statisticsData={statsPerWeek}
                          statsTotalLabel={"in Last 4 Weeks"}
                        />
                      </TabPanel>
                      <TabPanel value="3">
                        <DashboardChartMessageStatisticsByFacility
                          statisticsData={statsPerFacility}
                        />
                      </TabPanel>
                    </TabContext>
                  </Box>
                </Row>
              </Col>
            </Row>
          </Card>
        </Container>
      )}
      {componentIsVisible(DEStats, user) && (
        <Container
          fluid
          className="cardContainer"
          style={{ minHeight: "100vh" }}
        >
          <Card className="card">
            <Row>
              <Col>
                <Row>
                  <Card.Body>
                    <div className="cardBody">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}graph-img.png`}
                        className="graphImgStyle"
                        alt=""
                      ></img>
                      Error Statistics{" "}
                    </div>
                  </Card.Body>
                </Row>
                <Row>
                  <Box sx={{ width: "100%", typography: "body1" }}>
                    <TabContext value={errorTab}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleErrorTabChange}
                          aria-label="Error Statistics"
                        >
                          <AntTab label="Received by Day" value="1" />
                          <AntTab label="by Week" value="2" />
                          <AntTab label="by Facilities" value="3" />
                        </TabList>
                      </Box>
                      <TabPanel value="1">
                        <DashboardChart
                          errorsData={errorsPerDay}
                          isErrorChart={true}
                          isErrorPerDay={true}
                        />
                      </TabPanel>
                      <TabPanel value="2">
                        <DashboardChart
                          errorsData={errorsPerWeek}
                          isErrorChart={true}
                          isErrorPerWeek={true}
                        />
                      </TabPanel>
                      <TabPanel value="3">
                        <DashboardChart
                          errorsData={errorsPerFacility}
                          isErrorChart={true}
                          isErrorPerFacility={true}
                        />
                      </TabPanel>
                    </TabContext>
                  </Box>
                </Row>
              </Col>
            </Row>
          </Card>
        </Container>
      )}
    </>
  );
};

export default Dashboard;
